import { Button, Group, Select, Stack } from '@mantine/core';
import { useForm } from '@mantine/form';
import { i18nKeys, tKeysLoose, useTranslation } from 'locales';
import {
  PAYMENT_PLAN_STEP_TYPES,
  RECOVERY_STEP_TYPES,
  type StepType,
  useUpdateTemplate,
} from '../api';

type ChangeTemplateTypeModalProps = {
  templateId: string;
  planType: string;
  stepType: string;
  onClose: () => void;
};

export const ChangeTemplateTypeModal = ({
  templateId,
  planType,
  stepType,
  onClose,
}: ChangeTemplateTypeModalProps) => {
  const { t } = useTranslation();
  const { updateTemplate, isUpdateTemplateLoading } = useUpdateTemplate();

  const stepTypes = planType === 'payment' ? PAYMENT_PLAN_STEP_TYPES : RECOVERY_STEP_TYPES;

  const form = useForm({ initialValues: { stepType: stepType as StepType } });

  const handleSubmit = form.onSubmit(values => {
    if (values.stepType === stepType) {
      onClose();
      return;
    }
    updateTemplate({ id: templateId, stepType: values.stepType }, { onSuccess: onClose });
  });

  return (
    <form onSubmit={handleSubmit}>
      <Stack>
        <Select
          label={t(i18nKeys.FORM.TYPE)}
          allowDeselect={false}
          data={stepTypes.map(type => ({
            value: type,
            label: t(tKeysLoose.TEMPLATE_TYPES[type.toUpperCase()]),
          }))}
          {...form.getInputProps('stepType')}
        />
        <Group justify="flex-end" mt="md">
          <Button variant="default" onClick={onClose}>
            {t(i18nKeys.CANCEL)}
          </Button>
          <Button type="submit" loading={isUpdateTemplateLoading}>
            {t(i18nKeys.SAVE)}
          </Button>
        </Group>
      </Stack>
    </form>
  );
};
